// Copied from Kona - https://bitbucket.org/plaudit/kona-cabinetry-design-konacabinetry.com/src/master/wp-content/themes/custom/preprocess/lib/GenericSearch.ts

// Filter Interfaces - Teams and Pests
// https://lunrjs.com/  (or maybe http://elasticlunr.com/)
// https://lunrjs.com/guides/getting_started.html

import $ from "jquery";
import Debouncer from './Debouncer';

import lunr from 'lunr';
import replaceStemerWithOneThatKeepsOriginalAndStems from '../lib/lunr/replaceStemerWithOneThatKeepsOriginalAndStems';

const tableSelector = 'table.products-table';
const skuInputSelector = '.product-row__sku';
const documents: Array<any> = [];
const columnNames: Array<string> = [];
let idx: lunr.Index;

const $table = $(tableSelector);
if ($table.length) {
	// Documents to be indexed. Look for elements with @data-obj attribute and grabs json from @data-obj
	// MR: why is this being done? This is just overridden by the next code... It would also need to be "tr:nth-child(2)" on this site...
	/* $table.find('thead > tr > th').each((columnIndex, th) => {
		columnNames[columnIndex] = $(th).find('[data-search-field]').attr('data-search-field');
	}); */

	// get the product table filters - we removed these from the table for mobile design purposes
	// MR: not going to do this because of issues:
	// Bug 1: was working on https://localhost:3000/product/cwdm-mux-demux-single-fiber/ but not when "No" was selected for "Upgrade/Express Port". It was working for "Yes".
	// Bug 2: did not work on https://localhost:3000/product/coexistence-element-cex/ - the options contain spaces and special characters (e.g. "1x CEx LGX LC/APC & LC/UPC adapter ports") - was not returning anything.
	//query = "+objType:product +cex\\-type:cextypewospecialchar"; // putting single or double quotes around the value (cextypewospecialchar) breaks the query. You're supposed to be able to use double quotes to require an exact match.
	//query = "+objType:product +cex\\-type:i-have"; // you aren't supposed to have to escape the hyphen. The query would only work with "ihave", and then it was returning everything containing "i-have"
	/* const $tableFilters = $('.products-table__filters');
	$tableFilters.find('.products-table__filterItem').each((columnIndex, item) => {
		columnNames[columnIndex] = $(item).find('[data-search-field]').attr('data-search-field');
	}); */
	columnNames[0] = 'sku';

	// Get all data from table
	const $objs = $table.find('tbody > tr');
	$objs.each((index, element) => {
		const doc: any = {};

		//$(element).find('td').each((columnIndex, td) => {
		$(element).find(skuInputSelector).each((columnIndex, td) => {
			const name = columnNames[columnIndex];

			// if no column name stop? 
			if (!name) {
				return;
			}

			let value;
			// if multiple elements, get specific elem data by class
			const valueFrom = $(td).find('.product-row__set-value');
			if (valueFrom.length > 0) {
				value = valueFrom.text();
			} else {
				value = td.textContent;

			}

			value = value.trim();
			if (value.match(/^[^\s]+\-[^\s]+$/)) {
				// TODO: this needs to be updated for this site. The values tend to contain many hyphens, not just one.
				// Hack to get SW-AW1236 to be indexed as "SW-AW1236 SWAW1236"
				//   without doing this you SWAW1236 (w/o hyphen) will not match
				doc[name] = value + ' ' + value.replace(/\-+/, '');
			} else {
				doc[name] = value;
			}
		});
		doc.id = element.getAttribute('data-obj-id');
		doc.objType = element.getAttribute('data-obj');
		doc.domElement = element;

		documents.push(doc);
	});

	// Create searchable index of documents
	idx = lunr(function () {
		this.use(replaceStemerWithOneThatKeepsOriginalAndStems);

		const refName = 'id';

		this.ref(refName);	// 'id' is default

		documents.forEach((doc) => {

			// Must inform of fields before indexing
			for (const propName in doc) {
				if (!(this._fields as any)[propName]) {
					this.field(propName);
				}
			}

			// Add document
			this.add(doc);
		});
	});

	// Search index
	const $searches = $('[data-search-obj]');

	// When a value changes
	const updateResults = (event: JQuery.TriggeredEvent) => {
		// Find search container
		const $searchContainer = $(event.target).closest('[data-search-obj]');
		updateSearchResults($searchContainer, false);

		event.preventDefault();
	};
	$searches.on('change submit', updateResults);
	$searches.on('keyup', new Debouncer(updateResults, false, 1000).run);

	// When user clicks back in history
	/* window.onpopstate = function(event: Event) {
		if(event) {
			updateFormBasedOnURL();
		}
	}; */

	init();
}

function updateSearchResults($searchContainer: JQuery, updateHistory: boolean = true) {
	// Construct query
	// https://lunrjs.com/guides/searching.html
	let query = '';

	// Determine object type we are searching
	const objType = $searchContainer.attr('data-search-obj');
	query += '+objType:' + objType;

	// get query params from url
	//const params = new URLSearchParams();

	// Add value from form input fields to query
	const $fields = $searchContainer.find('[data-search-field]');

	$fields.each((index, element) => {
		const input = element as HTMLInputElement;
		let inputName = input.getAttribute('data-search-field');

		// const inputName = input.getAttribute('name');
		let field = input.getAttribute('data-search-field');



		// Clean value so it is safe for use in queries
		// MR: this would need to be added for column names like "CEx type", the query needs to be "+cex\\-type:blah"
		//field = field.replace(/-/g, '\\-');



		// const type = input.getAttribute('type') ?? 'select';
		let value: string = input.value;

		// Add to params for pushState
		/* if (inputName && value.length > 0) {
			params.append(inputName, value);
		} */

		// Clean value so it is safe for use in queries
		value = value.replace(/[^\sA-Za-z_\-0-9]+/g, '');

		// Add value to query
		if (value.length > 0) {
			value.split(/[\s\-]+/).forEach((value) => {
				if (value.length > 0) {
					// TODO: do not add '*' to all
					query += ' +' + field + ':' + value + '*';
				}
			});
		}
	});

	/* if (updateHistory) {
		// State - Update location bar
		let url = $searchContainer.attr('action').toLowerCase().replace(/\s/g , "-");
		const paramAsString = params.toString();

		if (paramAsString) {
			url += '?' + paramAsString;
		}
		history.pushState({}, '', url);
	} */

	// Lunr - Conduct search
	const matches: Array<lunr.Index.Result> = idx.search(query);
	const matchIds = matches.map(result => result.ref);

	// if no matches show 'no results' message
	// TODO: fix if turning SKU field back on.
	/* if (!matches.length) {
		document.querySelector('.productResultsLayout__noResults').classList.add('show');
	} else {
		document.querySelector('.productResultsLayout__noResults').classList.remove('show');
	} */

	documents.forEach((doc) => {
		if (doc.objType === objType) {
			// One that we are dealing with
			if (matchIds.indexOf(doc.id) >= 0) {
				// console.log('match', doc.id, doc);
				doc.domElement.setAttribute('search-match', 'true');
			} else {
				// console.log('not a match', doc.id, matchIds.indexOf(doc.id));
				doc.domElement.setAttribute('search-match', 'false');
			}
		}
	});
}


/* function updateFormBasedOnURL() {
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	const $form = $('form[data-search-obj]');

	// Update form fields.
	$form.find('[data-search-field]').each((index, input: HTMLInputElement) => {
		if(params.get(input.getAttribute('data-search-field'))) {
			input.value = params.get(input.getAttribute('data-search-field'));
		}
	});

	// Update results
	updateSearchResults($form, false);
}; */

function convertFractionToNumber(value: string) {
	value = value.replace(/"/g, '');
	value = value.replace(/ +/g, '+');
	if (value.match(/^[0-9\+\/]+$/)) {
		return eval(value);
	}
	return false;
}
function init() {
	// Add existing data to form fields
	columnNames.forEach((col, index) => {
		let colSelector = '#product-' + col;
		let formElement = $(colSelector);
		if (!formElement.is('select')) {
			return;
		}

		documents.map(item => item[col])
			.filter((value, index, self) => self.indexOf(value) === index)
			.map(item => {
				const opt = document.createElement('option');
				opt.value = item;
				opt.text = item;
				return opt;
			})
			.sort((a, b) => {
				const aN = convertFractionToNumber(a.value);
				const bN = convertFractionToNumber(b.value);
				if (aN !== false && bN !== false) {
					// TODO: convert fractions
					return aN - bN;
				}
				if (a && a.value !== null && a.value != undefined) {
					return a.value.localeCompare(b.value);
				}
				return 0;
			})
			.forEach((opt) => {
				(formElement.get(0) as HTMLSelectElement).add(opt);
			});
	});

	//updateFormBasedOnURL();






	/* Montclair variable product table lightbox
	-------------------------------------------------------- */
	const table = document.querySelector(tableSelector);
	const thCells_row1 = table.querySelectorAll('thead tr:first-child th');
	const tableSorterSelector = '.products-table__sorter';
	const thCells_row1_hasButton = Array.from(thCells_row1).filter(function(th) {
		return th.querySelector(tableSorterSelector) !== null;
	});
	const thCells_row2 = table.querySelectorAll('thead tr:nth-child(2) th');
	const tableRows = document.querySelectorAll('.products-table tbody tr');
	const selectMenus = document.querySelectorAll('.products-table__filterItem select');
	let firstSelectMenuIndex = -1; // Initialize with -1 (not found)
	const selectedValues = new Array(selectMenus.length).fill('');
	const lightbox = document.getElementById("lightbox");
	const lightboxOpenClass = 'open';
	const lightboxOverlay = document.querySelector('.lightbox__overlay');
	const lightboxClose = document.querySelector('.lightbox__close-button');
	const lightboxSave = document.querySelector('.productsLightbox__saveButton');

	// Populate dropdown options in thead
	// --- Assumes that all <th> following the first <th> with a <select> also contain a <select> - not great
	for (let index = 0; index < thCells_row2.length; index++) {
		const th = thCells_row2[index];
		const selectMenu = th.querySelector('select');
		if (selectMenu) {
			firstSelectMenuIndex = index;
			break;
		}
	}
	selectMenus.forEach((selectMenu, index) => {
		const columnCells = Array.from(table.querySelectorAll(`tbody td:nth-child(${index + firstSelectMenuIndex + 1})`));
		const uniqueValues = [...new Set(columnCells.map(cell => cell.textContent))];
		uniqueValues.forEach(value => {
			const option = document.createElement('option');
			option.value = value;
			option.text = value;
			(selectMenu as HTMLSelectElement).add(option);
		});
	});

	// Update table based on dropdown selections
	function updateRowAttributes() {
		let hasMatches = false;

		tableRows.forEach((row) => {
			let allSelected = true;
			selectMenus.forEach((select, index) => {
				const selectedValue = selectedValues[index];
				const rowValue = row.children[index + firstSelectMenuIndex].textContent;
				if (selectedValue !== '' && rowValue !== selectedValue) {
					allSelected = false;
				}
			});

			// NOTE: modifying this code to use search-match was causing issues...the attributes in the DOM weren't updating?!...
			row.setAttribute('non-lunr-search-match', allSelected ? 'true' : 'false');

			if (allSelected) {
				hasMatches = true;
			}
		});

		// if no matches show 'no results' message
		if (!hasMatches) {
            document.querySelector('.productResultsLayout__noResults').classList.add('show');
		} else {
            document.querySelector('.productResultsLayout__noResults').classList.remove('show');
        }
	}

	selectMenus.forEach((select: HTMLSelectElement, index) => {
		select.addEventListener('change', () => {
			selectedValues[index] = select.value;
			updateRowAttributes();
		});
	});

	updateRowAttributes();

	// Update form fields when product is selected in table by clicking select button (fake radio)
	const productsTableSelectButtons = document.querySelectorAll('.product-row__select');
	const selectActiveClass = 'active';
	const form = document.querySelector('.variations_form') as HTMLFormElement;
	const formFields = form.querySelectorAll('select');
	const popupTrigger = document.querySelector('.view-products-table');
	const tableSkus = document.querySelectorAll(skuInputSelector);
	const clearButton = document.querySelector('.reset_variations') as HTMLButtonElement;
	let selectedRow: HTMLElement;

	// Need to make entire row clickable instead of just the fake radio
	/* productsTableSelectButtons.forEach(el => {
		el.addEventListener('click', () => {
			resetSelectButtons();
			el.classList.add(selectActiveClass);
			const adjacentTableCells = [...el.closest('tr').querySelectorAll('.product-row__dropdown-attribute')]
				.map(td => td.textContent);
			formFields.forEach((select, index) => {
				if (select instanceof HTMLSelectElement && index < adjacentTableCells.length) {
					select.value = adjacentTableCells[index];
				}
			});
		});
	}); */
	table.addEventListener('click', (event) => {
		const cell = (event.target as Element)?.closest('td');
		if (cell) {
			var row = cell.parentElement;
			var selectButton = row.querySelector('.product-row__select');
			if (selectButton) {
				resetSelectButtons();
				selectButton.classList.add(selectActiveClass);
				selectedRow = row;
			}
		}
	});

	// Launch lightbox and populate table dropdowns when clicking on lightbox trigger
	popupTrigger.addEventListener('click', (ev) => {
		ev.preventDefault();
		resetSelectButtons();
		lightbox.classList.add(lightboxOpenClass);
		document.documentElement.classList.add('lockScroll');
		const skuArray = Array.from(tableSkus).map(element => element.textContent);
		const targetSku = document.querySelector('.sku_wrapper__sku');
		if (targetSku.textContent) {
			const targetSkuText = targetSku.textContent;
			const index = skuArray.indexOf(targetSkuText);
			productsTableSelectButtons[index].classList.add(selectActiveClass);
		}
	});

	// Close lightbox
	function closeLightbox() {
		lightbox.classList.remove(lightboxOpenClass);
		document.documentElement.classList.remove('lockScroll');

		// Set the form fields to the correct product
		if (selectedRow) {
			// Clear the form since some options disappear depending on what options are selected
			if (clearButton) {
				clearButton.click();
			}
			const valuesOfCells = [...selectedRow.querySelectorAll('.product-row__dropdown-attribute')].map(td => td.textContent);
			formFields.forEach((select, index) => {
				if (select instanceof HTMLSelectElement && index < valuesOfCells.length) {
					select.value = valuesOfCells[index];
				}
			});
		}

		// The following simulates the user changing a form dropdown and is needed for the "Description" and "Part No." to appear
		// It can't be run while the popup is open and the user has the ability to select other variations (b/c options are removed from the form dropdowns based on the values of the other form dropdowns)
		const event = new Event('change', {
			bubbles: true,
			cancelable: true,
		});
		formFields.item(0).dispatchEvent(event);
	}
	lightboxClose.addEventListener('click', closeLightbox);
	lightboxSave.addEventListener('click', closeLightbox);
	lightboxOverlay.addEventListener('click', closeLightbox);
	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeLightbox();
		}
	});

	const resetSelectButtons = () => {
		productsTableSelectButtons.forEach(element => {
			element.classList.remove(selectActiveClass);
		});
	};

	// Table sorting
	// --- Assumes that all <th> following the first <th> with a <button> also contain a <button> - not great
	let indexOfFirstButtonHeader = -1;
	for (let i = 0; i < thCells_row1.length; i++) {
		if (thCells_row1[i].querySelector(tableSorterSelector)) {
			indexOfFirstButtonHeader = i;
			break;
		}
	}

	function sortTable(columnIndex: number, reverse: boolean) {
		const tbody = table.querySelector('tbody')
		const rows = Array.from(tbody.rows);

		rows.sort((a, b) => {
			const aValue = a.cells[columnIndex + indexOfFirstButtonHeader].textContent.trim();
			const bValue = b.cells[columnIndex + indexOfFirstButtonHeader].textContent.trim();
			return reverse ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
		});

		while (tbody.firstChild) {
			tbody.removeChild(tbody.firstChild);
		}

		rows.forEach(row => {
			tbody.appendChild(row);
		});
	}

	thCells_row1_hasButton.forEach((header, index) => {
		if (header.querySelector(tableSorterSelector)) {
			header.addEventListener('click', () => {
				const currentSort = header.getAttribute('data-sort');
				const isReverse = currentSort === 'asc';

				const newSort = isReverse ? 'desc' : 'asc';
				header.setAttribute('data-sort', newSort);
				header.querySelector(tableSorterSelector + ' span').textContent = isReverse ? 'Sort ▼' : 'Sort ▲';

				thCells_row1_hasButton.forEach((otherHeader, otherIndex) => {
					if (otherIndex !== index) {
						otherHeader.setAttribute('data-sort', 'none');
						otherHeader.querySelector('button span').textContent = 'Sort';
					}
				});

				sortTable(index, isReverse);
			});
		}
	});
}